<template>
    <el-container class="page-x" direction="vertical">
        <div class="search-x">
            <div class="search-item">
                <span class="label">用户名</span>
                <el-input class="input-box" clearable v-model.trim="searchBox.loginName"></el-input>
            </div>
            <div class="search-item">
                <span class="label">姓名</span>
                <el-input class="input-box" clearable v-model.trim="searchBox.realName"></el-input>
            </div>
            <div class="search-item">
                <span class="label">时间</span>
                <el-date-picker
                        :picker-options="{
                            disabledDate(time) {
                                return time.getTime() > Date.now();
                            },
                        }"
                        v-model="timeRange"
                        type="daterange"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :default-time="['00:00:00', '23:59:59']"
                        range-separator="到"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
            </div>
            <el-button  type="primary" v-auth="'sa_operate_log_index'"  @click="search">查询</el-button>
        </div>
        <div class="pagination mb20">
            <el-pagination @current-change="handleCurrentChange"
                           :current-page="searchBox.pageNum"
                           :page-size="searchBox.pageSize"
                           layout="total,  prev, pager, next, jumper"
                           :total="total"
                           background>
            </el-pagination>
        </div>
        <div class="table-x" ref="tableBox">
            <el-table v-loading="loading"
                      :data="tableData"
                      border
                      class="mb20">
                <el-table-column type="index"
                                 align="center"
                                 label="序号"
                                 width="80">
                </el-table-column>
                <el-table-column prop="loginName"
                                 align="center"
                                 label="用户名"
                                 min-width="100">
                </el-table-column>
                <el-table-column prop="realName"
                                 align="center"
                                 label="姓名"
                                 min-width="100">
                </el-table-column>
                <el-table-column prop="content"
                                 align="center"
                                 label="操作内容"
                                 min-width="260">
                </el-table-column>
                <el-table-column align="center"
                                 label="操作时间"
                                 min-width="160">
                    <template slot-scope="scope">
                        {{ scope.row.createTime | date('%Y-%m-%d %T')}}
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页部分 -->
        <div class="pagination mb20">
            <el-pagination @current-change="handleCurrentChange"
                           :current-page="searchBox.pageNum"
                           :page-size="searchBox.pageSize"
                           layout="total,  prev, pager, next, jumper"
                           :total="total"
                           background>
            </el-pagination>
        </div>
    </el-container>
</template>

<script>
    export default {
        data() {
            return {
                searchBox: {
                    loginName: '',
                    realName: '',
                    pageNum: 1,
                    pageSize: 20
                },
                tableHeight: 0,
                timeRange: [],
                loading: false,
                tableData: [],
                total: 0
            }
        },
        created(){
            this.$root.breadList = [
                {name: '系统管理', link: ''},
                {name: '系统日志', link: '/system/log'},
            ]
        },
        mounted() {
            this.$nextTick(() => {
                this.tableHeight = this.$refs.tableBox.offsetHeight;
                this.getData();
            });
        },
        methods: {
            search() {
                this.searchBox.pageNum = 1;
                this.getData();
            },
            getData(){
                this.loading = true;
                let p = {
                    ...this.searchBox,
                    startTime: this.timeRange ? this.timeRange[0] : '',
                    endTime: this.timeRange ? this.timeRange[1] : '',
                }
                this.axios
                    .get(this.getApiUrl("operateLogIndex"), {
                        params: p,
                    })
                    .then((res) => {
                        this.loading = false;
                        if (res.code === 1) {
                            this.tableData = res.data.data || [];
                            this.total = res.data.total;
                        } else {
                            this.$message.warning(res.msg);
                        }
                    })
                    .catch((err) => {
                        this.loading = false;
                        console.log(err);
                    });
            },
            handleCurrentChange (val){
                this.searchBox.pageNum = val;
                this.getData();
            }
        }

    }
</script>

<style lang="scss" scoped type="text/scss">

</style>